import { requests } from '.';
const MediaServices = {
    listFiles: (params) => requests().get('/medias/files/', { params }),
    listBackgrounds: (params) => requests().get('/medias/backgrounds', { params }),
    listTextures: (params) => requests().get('/medias/textures', { params }),
    createUploadSignedUrl: (params) => requests().post('/medias/files/', params),
    verifyFileUpload: (params) => requests().post('/medias/files/verify', params),
    createFolder: (params) => requests().post('/medias/folder', params),
    deleteObject: (params) => requests().delete(`/medias/${params.id}`, {
        params: {
            altId: params.altId,
            altType: params.altType,
        },
    }),
    renameObject: (params) => requests().post(`/medias/${params.id}`, {
        name: params.name,
        altId: params.altId,
        altType: params.altType,
    }),
    startMigration: (params) => requests().post(`/medias/migrate`, params),
    checkMigrationStatus: (params) => requests().get(`/medias/migration-status`, { params }),
    moveFile: (params) => requests().post(`/medias/move`, params),
    addFile: (params) => requests().post(`/medias/add`, params),
    initiateEncoding: (params) => requests().post(`/medias/encode`, params),
    getLocationUsage: (params) => requests().get(`/medias/location/usage`, { params }),
};
export default MediaServices;
